import { defineComponent as _defineComponent } from 'vue'
import BroughtTogetherTile from "./BroughtTogetherTile.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BroughtTogether',
  setup(__props) {


return { __sfc: true,BroughtTogetherTile }
}

})